export { default } from "./TableSortLabel.mjs";
export { default as tableSortLabelClasses } from "./tableSortLabelClasses.mjs";
export * from "./tableSortLabelClasses.mjs";